import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        wDarkerBlue:'#192533',
        primary: '#1d2b3b',
        secondary: '#17c6e9',
        accent: '#fcc401',
        success: '#53a548',
        error: '#a52422',
        info: '#48beff',
        warning: '#fcfc62',
        backgroundCongresoCarne: '#4e4e4e', // Background en el checkout del congreso de la carne 661517  #CC3638 #9c1e21 #661517 #4e4e4e
      },
      dark:true,
    },
  },
});

